export default __webpack_public_path__ + "static/media/Hands_Blue.9d1ebe76.png";